import React from 'react'
import { ControlProps, getControlParts } from './Control'
import classNames from 'classnames'

import './Dropdown.scss'

export interface DropdownItem<T extends string | number> {
	value: T
	text: string
}

export interface DropdownProps<T extends string | number> extends ControlProps {
	items: Array<DropdownItem<T>>
	value?: T
	onChange: (value?: T) => void
	placeholder?: string
}

export function Dropdown<T extends string | number>(props: DropdownProps<T>) {

	const controlParts = getControlParts(props)

	const options = props.items.map((item, itemIndex) => {
		return (
			<option key={itemIndex} value={item.value}>{item.text}</option>
		)
	})

	if (props.placeholder || props.placeholder === '') {
		// let disabled = props.value && props.items.length == 1
		// options.unshift(<option key={-1} className='placeholder' disabled={disabled}>{props.placeholder}</option>)
		options.unshift(<option key={-1} className='placeholder'>{props.placeholder}</option>)
	}

	const handleChange: React.ChangeEventHandler<HTMLSelectElement> = (e) => {
		if (props.placeholder && e.target.value === props.placeholder) props.onChange(undefined)
	 	else props.onChange(e.target.value as T)
	}

	let className = classNames('select is-fullwidth', { blank: typeof props.value === 'undefined' }, { 'is-danger': props.errorMessage }, props.size && `is-${props.size}`)

	const inputControl = (
		<div className='dropdown-component field'>
			{controlParts.labelElement}
			<div className='control'>
				<div className={className}>
					<select id={controlParts.inputId} value={props.value || ''} onChange={handleChange} disabled={props.disabled}>
						{options}
					</select>
				</div>
			</div>
			{controlParts.helpTextElement}
		</div>
	)

	return props.isInColumn ? <div className='column'>{inputControl}</div> : inputControl
}

export default Dropdown